import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

interface ICourseTutorMappingState extends IReduxState<any> {
    saveData?: IAPIResponse<any>;
    availableTutorData?: IAPIResponse<any>;
}

const initialState: ICourseTutorMappingState = {
    isLoading: false,
    data: undefined,
    saveData: undefined,
    availableTutorData: undefined,
};

export const CourseTutorMappingSlice = createSlice({
    name: "CourseTutorMapping",
    initialState,
    reducers: {
        getCourseTutorMappingList: (state) => {
            state.isLoading = true;
        },
        successGetCourseTutorMappingList: (state, action) => {
            state.data = action.payload.data;
            state.isLoading = false;
        },
        failureGetCourseTutorMappingList: (state, action) => {
            state.data = action.payload.data;
            state.isLoading = false;
        },
        createEditCourseTutorMapping: (state) => {
            state.isLoading = true;
        },
        successCreateEditCourseTutorMapping: (state, action) => {
            state.saveData = action.payload.data;
            state.isLoading = false;
        },
        failureCreateEditCourseTutorMapping: (state, action) => {
            state.saveData = action.payload.data;
            state.isLoading = false;
        },
        clearCourseTutorMappingResponse: (state) => {
            state.saveData = undefined;
        },
        getAvailableTutorList: (state) => {
            state.isLoading = true;
        },
        successGetAvailableTutorList: (state, action) => {
            state.availableTutorData = action.payload.data;
            state.isLoading = false;
        },
        failureGetAvailableTutorList: (state, action) => {
            state.availableTutorData = action.payload.data;
            state.isLoading = false;
        },
    },
});

export const {
    getCourseTutorMappingList,
    successGetCourseTutorMappingList,
    failureGetCourseTutorMappingList,
    createEditCourseTutorMapping,
    successCreateEditCourseTutorMapping,
    failureCreateEditCourseTutorMapping,
    clearCourseTutorMappingResponse,
    getAvailableTutorList,
    successGetAvailableTutorList,
    failureGetAvailableTutorList,
} = CourseTutorMappingSlice.actions;

export default CourseTutorMappingSlice.reducer;
